import api from 'src/services/api';
import * as utils from './apiUtils';
import {
  type TagMovieUpdateResponseRaw,
  toTagMovieUpdate,
} from 'src/models/apis/tagMovie/tagMovieResponse';
import type { TagMovieUpdateResponse } from 'src/models/tagMovie';
import type { TagMovieUpdateParams } from 'src/models/apis/tagMovie/tagMovieRequest';

export default {
  async update(movieId: number, params: TagMovieUpdateParams): Promise<TagMovieUpdateResponse> {
    const response = await api.put<TagMovieUpdateResponseRaw>(utils.getApiUrl(`/movies/${movieId}/tags`), params);
    return toTagMovieUpdate(response.data);
  },
};
